import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  Button,
  Skeleton,
} from "@mui/material";
import { useSelector } from "react-redux";
import configServ from "../../services/config";

const Prescriptions = () => {
  const { customer_id } = useSelector((state) => state.GlobalVariables);
  const [loading, setLoading] = useState(false);
  const [prescriptions, setPrescriptions] = useState([]);
  

  const getYoutubeThumbnail = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return `https://img.youtube.com/vi/${videoId}/0.jpg`;
  };

  useEffect(() => {
    const fetchPrescriptions = async () => {
      setLoading(true);
      try {
        const response = await configServ.getPrescriptionForCustomer({
          customer_id: customer_id,
        });
        if (response.status === 200) {
          setPrescriptions(
            response.data.prescriptions.map((prescription) => ({
              id: prescription.id,
              doctorName: prescription.prescribed_by,
              date: prescription.prescribed_at,
              exercises: prescription.solutions.map((solution) => ({
                title: solution.item_name,
                description: solution.description,
                duration: `${solution.duration} Days`,
                videoLink: solution.product_video.length
                  ? solution.product_video[0].video_url
                  : "",
              })),
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching prescriptions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrescriptions();
  }, [customer_id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date);
  };

  return (
    <div style={{ padding: "1px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Prescriptions
      </Typography>

      {loading ? (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={150}
          sx={{ borderRadius: 2 }}
        />
      ) : prescriptions.length === 0 ? (
        <Typography variant="h6" align="center" color="textSecondary">
          No prescription found.
        </Typography>
      ) : (
        prescriptions.map((prescription) => (
          <Paper
            key={prescription.id}
            sx={{ mb: 4,  borderRadius: 2,  }}
          >
            {/* Doctor Info */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6">
                  Practitioner: <strong>{prescription.doctorName}</strong>
                </Typography>
                <Typography variant="body1">
                  Date: <strong>{formatDate(prescription.date)}</strong>
                </Typography>
              </CardContent>
            </Card>

            {/* Exercises List */}
            {prescription.exercises.map((exercise, index) => (
              <Card key={index} sx={{ mb: 3, }}>
                <CardContent>
                  <Typography variant="h6">{exercise.title}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {exercise.description}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    Duration: {exercise.duration}
                  </Typography>

                  {/* Video Section */}
                  {exercise.videoLink && (
                    <Paper
                      sx={{
                        mt: 2,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        boxShadow: 1,
                      }}
                    >
                      <img
                        src={getYoutubeThumbnail(exercise.videoLink)}
                        alt="Thumbnail"
                        style={{
                          width: "100px",
                          height: "60px",
                          borderRadius: "5px",
                        }}
                      />
                      <div style={{ marginLeft: "10px" }}>
                        <Typography variant="body2" color="textSecondary">
                          Watch the demonstration to understand the exercise
                          better.
                        </Typography>
                        {/* <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          href={exercise.videoLink}
                          target="_blank"
                          sx={{ mt: 1 }}
                        >
                          See Video
                        </Button> */}
                      </div>
                    </Paper>
                  )}
                </CardContent>
              </Card>
            ))}
          </Paper>
        ))
      )}
    </div>
  );
};

export default Prescriptions;
